import { Directive, ElementRef, HostBinding, Input } from '@angular/core';
import { UrlTree } from '@angular/router';
import { IconName } from '../../icon/components/icon/icon.component';

@Directive({
  selector: '[app-narrow-sidebar-nav-list-item]',
})
export class NarrowSidebarNavListItemDirective {
  @Input() @HostBinding('routerLink') routerLink?: string | readonly any[] | UrlTree | null | undefined;
  @Input() icon?: IconName;

  constructor(private el: ElementRef<HTMLButtonElement>) {}

  get textContent() {
    return this.el.nativeElement.textContent;
  }
}
